import { withStyles } from "tss-react/mui";
import { Textsms } from "@mui/icons-material";
import axios from "axios";
import React from "react";
import { connect } from "react-redux";
import rapportenStyle from "../../../assets/jss/material-dashboard-pro-react/views/rapportenStyle";
import Card from "../../../components/Card/Card";
import CardFooter from "../../../components/Card/CardFooter";
import CardHeader from "../../../components/Card/CardHeader";
import CardIcon from "../../../components/Card/CardIcon";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import * as actions from "../../../store/actions";
import Filters from "../Components/Filters";

import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import { toast } from "react-toastify";
import { format } from "date-fns";

class Main extends React.Component {
  state = {
    sendSmsCount: 0,
  };

  currentReqeust;

  componentWillUnmount() {
    /**
     * Current request annuleren bij snel klikken kan zijn dat die nog niet klaar is
     */
    if (this.currentReqeust !== undefined) {
      this.currentReqeust.cancel();
    }
  }

  getData = (filterData) => {
    toast.info(<TranslationWrapper tDefault={"laden"} tKey={"global.laden"} />);

    let data = {
      vestiging_ids: filterData.vestiging_ids,
      start_datum: format(new Date(filterData.start_datum), "yyyy-M-d HH:mm:ss"),
      eind_datum: format(new Date(filterData.eind_datum), "yyyy-M-d HH:mm:ss"),
    };

    if (this.currentReqeust !== undefined) {
      this.currentReqeust.cancel();
    }

    const CancelToken = axios.CancelToken;
    this.currentReqeust = CancelToken.source();
    let cancelToken = this.currentReqeust.token;

    axios
      .post("core/rapporten/overige_message_genereer", data, {
        cancelToken: cancelToken,
      })
      .then((response) => {
        let newState = { ...this.state, ...response.data.data };
        this.setState(newState);
      })
      .catch((error) => {
        /**
         * Alleen niet CANCEL errors afvangen
         */
        if (!error.__CANCEL__) {
          toast.error(
            <TranslationWrapper tDefault={"Oeps er is iets misgegaan!"} tKey={"global.rapporten.errormessage"} />
          );
        }
      });
  };

  render() {
    const { classes } = this.props;

    return (
      <div>
        <Filters onFilterChange={this.getData} showEndDate showStartDate showVestigingen />
        <GridContainer>
          <GridItem lg={3} md={6} sm={6} xs={12}>
            <Card>
              <CardHeader color={"primary"} icon stats>
                <CardIcon color={"primary"}>
                  <Textsms />
                </CardIcon>
                <h3 className={classes.cardTitle}>{this.state.sendSmsCount}</h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <TranslationWrapper
                    tDefault={"verzonden sms over periode"}
                    tKey={"rapportages.rapporten.sendsms.periode"}
                  />
                </div>
              </CardFooter>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showMessage: (message) => dispatch({ type: actions.SHOW_MESSAGE, message: message }),
    closeMessage: () => dispatch({ type: actions.CLOSE_MESSAGE }),
  };
};

export default connect(null, mapDispatchToProps)(withStyles(Main, rapportenStyle));
